export function useCatalogAPI() {
  const { errors, request } = useRequestV2();

  async function getWholeSalers() {
    const url = 'V3/Catalog/GetWholeSalers';

    return await request<WholesalersResponse[]>(url);
  }

  async function SearchAllItems(requestBody: SearchAllItemsRequest, includeWholesalerImages: boolean, includeOwnItemImages: boolean) {
    const url = `V3/Catalog/SearchAllItems?includeWholesalerImages=${includeWholesalerImages}&includeOwnItemImages=${includeOwnItemImages}`;
    const requestOptions: RequestOptions = {
      method: 'post',
      body: requestBody
    };

    return await request<MaterialItemApp[]>(url, requestOptions);
  }

  async function CreatePersonalMaterialFavoriteList(requestBody: PersonalFavoriteListName) {
    const url = 'V3/Catalog/CreatePersonalMaterialFavoriteList';
    const requestOptions: RequestOptions = {
      method: 'post',
      body: requestBody
    };

    return await request<MaterialFavoriteList>(url, requestOptions);
  }

  async function addMaterialsToFavoriteList(requestBody: MaterialFavoriteListIdRecordIds) {
    const url = 'V3/Catalog/AddMaterialsToFavoriteList';
    const requestOptions: RequestOptions = {
      method: 'post',
      body: requestBody
    };

    return await request<boolean>(url, requestOptions);
  }

  async function removeMaterialsFromFavoriteList(requestBody: MaterialFavoriteListIdRecordIds) {
    const url = 'V3/Catalog/RemoveMaterialsFromFavoriteList';
    const requestOptions: RequestOptions = {
      method: 'post',
      body: requestBody
    };

    return await request<boolean>(url, requestOptions);
  }

  async function fetchWholesalerItemByElasticSearch(requestBody: AppIonicSearchItemRequestDTO, includeImages: boolean) {
    const url = `V3/Catalog/SearchWholesalerItemsElastic?includeImages=${includeImages}`;
    const requestOptions: RequestOptions = {
      method: 'post',
      body: requestBody
    };

    return await request<SearchItemResponse>(url, requestOptions);
  }

  async function GetMaterialFavoriteListsInfoConnectedToFitter() {
    const url = 'V3/Catalog/GetMaterialFavoriteListsInfoConnectedToFitter';
    const requestOptions: RequestOptions = {
      method: 'get'
    };

    return await request<FavoriteListInfoDTO[]>(url, requestOptions);
  }

  async function GetMaterialItemsForFavoriteListApp(requestBody: MaterialFavoriteListAppRequestDTO, isPersonalList: boolean, includeImages: boolean) {
    //change these after 2.0.26
    const url = `V3/Catalog/GetMaterialItemsForFavoriteListAppV2?isPersonalList=${isPersonalList}&includeImages=${includeImages}`;
    //const url = `V3/Catalog/GetMaterialItemsForFavoriteListApp?isPersonalList=${isPersonalList}&includeImages=${includeImages}`;
    
    const requestOptions: RequestOptions = {
      method: 'post',
      body: requestBody
    };

    return await request<FavoriteListItemApp>(url, requestOptions);
  }

  return {
    errors,
    fetchWholesalerItemByElasticSearch,
    CreatePersonalMaterialFavoriteList,
    getWholeSalers,
    addMaterialsToFavoriteList,
    removeMaterialsFromFavoriteList,
    GetMaterialFavoriteListsInfoConnectedToFitter,
    GetMaterialItemsForFavoriteListApp,
    SearchAllItems
  };
}
